const owlCarousel = require('owl.carousel'); // eslint-disable-line no-unused-vars

$('.owl-carousel--default').owlCarousel({
  loop: false,
  nav: true,
  dots: false,
  navText: [
    `
    <svg class="hpe-icon">
      <use xlink:href="#icon-previous" />
    </svg>
    `,
    `
    <svg class="hpe-icon">
      <use xlink:href="#icon-next" />
    </svg>`
  ],
  autoWidth: false,
  responsive: {
    0: {
      items: 1,
      nav: true
    },
    768: {
      items: 3
    },
    1100: {
      items: 4
    }
  }
});

$('.owl-carousel--narrow').owlCarousel({
  loop: false,
  nav: true,
  dots: false,
  navText: [
    `
    <svg class="hpe-icon">
      <use xlink:href="#icon-previous" />
    </svg>
    `,
    `
    <svg class="hpe-icon">
      <use xlink:href="#icon-next" />
    </svg>`
  ],
  autoWidth: false,
  responsive: {
    0: {
      items: 1,
      nav: true
    },
    768: {
      items: 3
    },
    1100: {
      items: 5
    }
  }
});

$('.owl-carousel--auto').owlCarousel({
  loop: false,
  nav: true,
  dots: false,
  navText: [
    `
    <svg class="hpe-icon">
      <use xlink:href="#icon-previous" />
    </svg>
    `,
    `
    <svg class="hpe-icon">
      <use xlink:href="#icon-next" />
    </svg>`
  ],
  autoWidth: true
});

const owlSingle = {
  CLASS_ACTIVE: 'owl-carousel-nav__item--active',

  $owlSingleNav: null,
  $owlSingleNavItems: null,
  currentItem: 0,

  init() {
    const self = this;

    const $owlSingle = $('.owl-carousel--single').owlCarousel({
      loop: false,
      nav: false,
      dots: false,
      margin: 10,
      responsiveClass: true,
      responsive: {
        0: {
          items: 1
        }
      }
    });

    this.$owlSingleNav = $('.owl-carousel-nav');
    this.$owlSingleNavItems = this.$owlSingleNav.find('.owl-carousel-nav__item');

    this.setCurrentItem(this.currentItem);

    this.$owlSingleNavItems.each(function (index) {
      const $el = $(this);
      $el.click(() => {
        $owlSingle.trigger('to.owl.carousel', [index, 300]);
        self.setCurrentItem(index);
      });
    });

    $owlSingle.on('changed.owl.carousel', function (event) {
      const { index } = event.item;
      self.setCurrentItem(index);
    });
  },

  setCurrentItem(index) {
    this.currentItem = index;

    this.$owlSingleNavItems.removeClass(this.CLASS_ACTIVE);
    this.$owlSingleNavItems.eq(index).addClass(this.CLASS_ACTIVE);
  }
};

owlSingle.init();



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/owl-carousel.js